import React, {Component} from 'react';
import { withRouter, Link } from 'react-router-dom';
//import {InputText} from 'primereact/inputtext';
import PropTypes from 'prop-types';
import { HashLink as HLink } from 'react-router-hash-link';
import { Button } from 'primereact/button';

import Tooltip from './shared/UI/Tooltip/Tooltip';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import jsPDF from "jspdf";
import 'jspdf-autotable';


class AppTopbar extends Component {

    state ={
        viewMyCalendar: false,
    }

    static defaultProps = {
        onToggleMenu: null
    }

    static propTypes = {
        onToggleMenu: PropTypes.func.isRequired 
    }

    logout = () => {

        confirmAlert({
          title: 'Do you want to quit?',
          message: 'Are you sure.',
          buttons: [
            {
              label: 'Yes',
              onClick: () => this.props.history.push('/log-out')
            },
            {
              label: 'No',
            //   onClick: () => alert('Click No')
            }
          ]
        });
      };

      downloadPS = () => {
        this.setState({ loadding: true });
        const{userPosInfo} = this.props;
            var doc = new jsPDF

            doc.autoTable({
                theme: 'plain',
                body: [[{
                    content: "PAYSLIP",
                    colSpan: 8,
                    styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 18, font: 'calibri'|'times'|'courier' }
                }]]
            });
            
            doc.autoTable({
                theme: 'grid',
                body: [
                        [
                            {
                            content: "Emp.no",
                            colSpan: 8,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier',lineColor: 'black', fillColor: '#dae3f2'
                            }},
                            {
                            content: "Employee Name",
                            colSpan: 8,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', fillColor: '#dae3f2'
                            }},
                            {
                            content: "Position",
                            colSpan: 8,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', fillColor: '#dae3f2'
                            }},
                        ], 
                        [
                            {
                            content: `${localStorage.getItem('userId')}` || '',
                            colSpan: 8,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier',lineColor: 'black'
                            }},
                            {
                            content: `${localStorage.getItem('userName')}` || '',
                            colSpan: 8,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black'
                            }},
                            {
                            content: '',
                            colSpan: 8,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black'
                            }},
                        ], 
                        [
                            {
                            content: "Month",
                            colSpan: 8,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier',lineColor: 'black', fillColor: '#dae3f2'
                            }},
                            {
                            content: "Joining Date",
                            colSpan: 3,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', fillColor: '#dae3f2'
                            }},
                            {
                            content: "Earned Days",
                            colSpan: 5,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', fillColor: '#dae3f2'
                            }},
                            {
                            content: "Unpaid Days",
                            colSpan: 4,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', fillColor: '#dae3f2'
                            }},
                            {
                            content: "Vacation Days",
                            colSpan: 4,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', fillColor: '#dae3f2'
                            }},
                        ],
                        [
                            {
                            content: '',
                            colSpan: 8,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier',lineColor: 'black'
                            }},
                            {
                            content: `${localStorage.getItem('doj')}` || '',
                            colSpan: 3,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black'
                            }},
                            {
                            content: '',
                            colSpan: 5,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black'
                            }},
                            {
                            content: '',
                            colSpan: 4,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black'
                            }},
                            {
                            content: '',
                            colSpan: 4,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black'
                            }},
                        ],
                ]
                
            });

            doc.autoTable({
                theme: 'grid',
                didDrawPage: HookData => {
                    },
                body: [
                        
                        [
                            {
                            content: "Earnings",
                            colSpan: 8,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier',lineColor: 'black', fillColor: '#dae3f2'
                            }},
                            {
                            content: "Amount",
                            colSpan: 3,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', fillColor: '#dae3f2'
                            }},
                            {
                            content: "Deductions",
                            colSpan: 5,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', fillColor: '#dae3f2'
                            }},
                            {
                            content: "Amount",
                            colSpan: 4,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', fillColor: '#dae3f2'
                            }},
                            {
                            content: "Netpay",
                            colSpan: 4,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', fillColor: '#dae3f2'
                            }},
                        ],
                        [
                            {
                            content: "Wage Types",
                            colSpan: 11,
                            styles: { halign: 'left', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier',lineColor: 'black', cellHeight: 30
                            }},
                            {
                            content: "Wage Types",
                            colSpan: 9,
                            styles: { halign: 'left', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', cellHeight: 30
                            }},
                            {
                            content: "",
                            colSpan: 4,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black'
                            }},
                        ],
                        [
                            {
                            content: "Gross Earnings",
                            colSpan: 4,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: "",
                            colSpan: 7,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', 
                            }},
                            {
                            content: "Total Deductions",
                            colSpan: 3,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', 
                            }},
                            {
                            content: "",
                            colSpan: 5,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', 
                            }},
                            {
                            content: "kwd",
                            colSpan: 5,
                            styles: { halign: 'right',valign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', 
                            }},
                        ],
                        [
                            {
                            content: "Salary Transfered to A/c :",
                            colSpan: 14,
                            styles: { halign: 'left', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: "Received By",
                            colSpan: 10,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', 
                            }}
                        ],
                        [
                            {
                            content: "Vacation Balance Days",
                            colSpan: 11,
                            styles: { halign: 'left', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: "OT Hours",
                            colSpan: 13,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', 
                            }}
                        ],
                        [
                            {
                            content: "",
                            colSpan: 11,
                            styles: { halign: 'left', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: "",
                            colSpan: 13,
                            styles: { halign: 'center', fillColor: 'white', textColor: 'black', fontStyle: 'bold', fontSize: 9, font: 'calibri'|'times'|'courier', lineColor: 'black', 
                            }}
                        ],
                ]
                
            });
            



            doc.save('Payslip.pdf');
            this.setState({ loading: false });
        }


    render() {
        let title = 'Shrink';
        let iconClass = 'pi pi-chevron-left';
        if(this.props.menuActive){
            title = 'Menu';
            iconClass = 'pi pi-bars';
        }


        let link ='#';
        if(this.props.userDetail!==null){
            link = '/employee-master/view/' +this.props.userDetail.userId;
        }
      

        return (
            <div className="layout-topbar clearfix">
                
                <Tooltip title={title}>
                    <button className="p-link" onClick={this.props.onToggleMenu} style = {{color: 'white'}}>
                        <span className={iconClass}/>
                    </button>
                </Tooltip>
                
                <div className="layout-topbar-icons">
                    {/* <span className="layout-topbar-search">
                        <InputText type="text" placeholder="Search" />
                        <span className="layout-topbar-search-icon pi pi-search"/>
                    </span> */}
          

                    <Button 
                    label="POS"
                    onClick={() => this.props.history.replace('/pos/')}
                    className="p-link"
                    style = {{color: 'white'}}>
                    </Button>

                    <Tooltip title="My calendar">
                        <HLink to="/dashboard#MyCalendar">
                        <button className="p-link">
                            <span className="pi pi-calendar"/>
                            <span className="pi pi-cal"/>
                        </button>
                        </HLink>
                    </Tooltip>

                    {/* <Tooltip title="Download Current Pay-Slip">
                        <button className="p-link" onClick= { () => this.downloadPS()}>
                            <span className="pi pi-download"/>
                            <span className="pi pi-cal"/>
                        </button>
                    </Tooltip> */}

                    {/* <Tooltip title="New Requests">
                        <Link to={'/dashboard'}>
                            <button className="p-link">
                                <span className=" pi pi-bell"/>
                                <span className="layout-topbar-badge" >{(localStorage.getItem('totalNotificationCount') ? localStorage.getItem('totalNotificationCount') : 0)}</span>
                            </button>
                        </Link>
                    </Tooltip>

                    <Tooltip title="Profile">
                        <Link to='#'>
                        <button className="p-link">
                            <span className="pi pi-user"/>
                        </button>
                        </Link>
                    </Tooltip> */}

                    <Tooltip title="Logout">
                        <button className="p-link" >
                            <span className="pi pi-power-off" onClick={this.logout} />
                        </button>
                    </Tooltip>




                    
                    
                </div>
            </div>
        );
    }
}

export default withRouter(AppTopbar);